import React, { useState } from "react";
import axios from "axios";
import DOMPurify from "dompurify";

function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const url = `${process.env.REACT_APP_API}/secure/forget`;
    // const url = `http://localhost:4000/secure/forget`;

    const data = {
      email: DOMPurify.sanitize(email, {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: [],
      }),
    };
    axios
      .post(url, data)
      .then((res) => {
        setLoading(false);
        setResponseMessage(res.data.message);
      })
      .catch((error) => {
        setLoading(false);
        setError(error.message);
      });
  };

  return (
    <div className="content-container">
      <div className="forgot-password-container">
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <h2 className="header-reset">Forgot password</h2>
          <input
            type="email"
            placeholder="Email"
            className="user-email"
            name="cpassword"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && (
            <div className="error-message" style={{ color: "red" }}>
              {error}
            </div>
          )}
          <button type="submit" className="password-button" disabled={loading}>
            {loading ? "Loading..." : "Forgot password"}
          </button>
          {responseMessage && (
            <div className="response-message" style={{ color: "green" }}>
              {responseMessage}
            </div>
          )}
        </form>
        {loading && <div className="loader">Loading...</div>}
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
